import {AbstractControl} from "@angular/forms";

export interface IFieldError {
  kind: string;
  message: string;
}

/**
 * Maps the active errors of a reactive form control to the error list expected by df-form-field.
 * Only errors listed in `messages` are returned, in the order of `messages`.
 */
export function controlErrors(control: AbstractControl, messages: Record<string, string>): IFieldError[] {
  if (!control?.errors) {
    return [];
  }
  return Object.keys(messages)
    .filter(kind => control.hasError(kind))
    .map(kind => ({kind, message: messages[kind]}));
}
